// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledCommentTextWrapper = styled.div`
	word-break: break-word;
	margin: 0 auto 0 0;
	width: 100%;
	padding-top: 0.25rem;

	${({ isPhone }) =>
		isPhone &&
		css`
			width: max-content;
			max-width: 400px;
		`}
`;

// #####################################################
